// Copyright (c) 2016 Deere & Company

import t from 'tcomb';

const ClaimComplaintCause = t.struct({
    basisForSettlement: t.String,
    causeOfComplaining: t.String,
    comments: t.String,
    howWasComplaintCorrected: t.String,
    operatorsComplaint: t.String
}, {
    name: 'ClaimComplaintCause',
    strict: true
});

export const getDefaultState = () => new ClaimComplaintCause({
    basisForSettlement: '',
    causeOfComplaining: '',
    comments: '',
    howWasComplaintCorrected: '',
    operatorsComplaint: ''
});

export default ClaimComplaintCause;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/claim-complaint-cause.js